export const PATRON_POTENCIA_ERROR = 'El valor admite hasta 11 enteros y hasta 3 decimales';
export const CAMPO_VACÍO_ERROR = 'El campo no puede estar vacío';
export const DELIMITADOR_DECIMALES_ERROR = 'El delimitador de decimales debe ser el punto';
export const RANGO_TARIFA_2_0_ERROR = 'El valor debe ser mayor a 0 y menor o igual a 15';
export const MAYOR_0_ERROR = 'El valor debe ser mayor a 0';
export const SIN_MAYOR_15_ERROR = 'Un valor debe ser mayor a 15kw';
export const ASCENDENTES_ERROR = 'Los valores deben ser ascendentes';
